import { Checkbox as RacCheckbox } from 'react-aria-components';
import { OptionKeyValue, OptionSelectComponent, CheckboxComponent } from '@myriadgenetics/mgh-types';
import './index.scss';

type Props = {
  children: any;
  className?: string;
  compDef: OptionSelectComponent | CheckboxComponent;
  onChange: (selectedOption: OptionKeyValue) => void;
  dataTestId?: string;
  value: string;
  labelKey: string;
  singleCheckbox?: boolean;
  isSelected?: boolean;
};

function Checkbox({ compDef, children, className, onChange, dataTestId, value, labelKey, singleCheckbox, isSelected }: Props) {
  const componentData = compDef;
  const { answerKey } = componentData?.data;

  const handleChange = (isSelected: boolean) => {
    if (singleCheckbox) {
      onChange({ optionKey: answerKey, optionValue: isSelected.toString() });
      return;
    }
    onChange({ optionKey: answerKey, optionValue: value });
  };

  return (
    <RacCheckbox
      key={value}
      className={`checkbox ${className ?? ''} text-medium--medium`}
      defaultSelected={isSelected}
      data-testid={dataTestId}
      name={labelKey}
      value={value}
      onChange={handleChange}
    >
      {children}
    </RacCheckbox>
  );
}

Checkbox.defaultProps = { disabled: false };

export default Checkbox;
